/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Pipe, PipeTransform} from '@angular/core';
import {invalidPipeArgumentError} from './invalid_pipe_argument_error';
/**
 * Transforms text to lowercase.
 * 
 * {\@example  common/pipes/ts/lowerupper_pipe.ts region='LowerUpperPipe' }
 * 
 * \@stable
 */
export class LowerCasePipe implements PipeTransform {
/**
 * @param {?} value
 * @return {?}
 */
transform(value: string): string {
    if (!value) return value;
    if (typeof value !== 'string') {
      throw invalidPipeArgumentError(LowerCasePipe, value);
    }
    return value.toLowerCase();
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{name: 'lowercase'}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function LowerCasePipe_tsickle_Closure_declarations() {
/** @type {?} */
LowerCasePipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LowerCasePipe.ctorParameters;
}

/**
 * Helper method to transform a single word to titlecase.
 * 
 * \@stable
 * @param {?} word
 * @return {?}
 */
function titleCaseWord(word: string) {
  if (!word) return word;
  return word[0].toUpperCase() + word.substr(1).toLowerCase();
}
/**
 * Transforms text to titlecase.
 * 
 * \@stable
 */
export class TitleCasePipe implements PipeTransform {
/**
 * @param {?} value
 * @return {?}
 */
transform(value: string): string {
    if (!value) return value;
    if (typeof value !== 'string') {
      throw invalidPipeArgumentError(TitleCasePipe, value);
    }

    return value.split(/\b/g).map(word => titleCaseWord(word)).join('');
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{name: 'titlecase'}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TitleCasePipe_tsickle_Closure_declarations() {
/** @type {?} */
TitleCasePipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TitleCasePipe.ctorParameters;
}

/**
 * Transforms text to uppercase.
 * 
 * \@stable
 */
export class UpperCasePipe implements PipeTransform {
/**
 * @param {?} value
 * @return {?}
 */
transform(value: string): string {
    if (!value) return value;
    if (typeof value !== 'string') {
      throw invalidPipeArgumentError(UpperCasePipe, value);
    }
    return value.toUpperCase();
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{name: 'uppercase'}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function UpperCasePipe_tsickle_Closure_declarations() {
/** @type {?} */
UpperCasePipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
UpperCasePipe.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
